module.exports = __webpack_public_path__ + "img/United States.11e23d5b.svg";